namespace $ {
	export class $shm_mentionstat_data extends $shm_wordstat_data {
		queries(): readonly string[] { return [] }
		scopes(): readonly string[] { return [] }
		countries(): readonly string[] { return [] }
		languages(): readonly string[] { return [] }
		types(): readonly string[] { return [] }
		categories(): readonly string[] { return [] }
		group() { return 'day' }

		registered_name() {
			return `mentionstat_${ this.app_id().replaceAll( /[^a-zA-Z0-9_]/g, '_' ) }.duckdb`
		}

		async table_ready_async( file_name: string ) {
			const source = this.file_source()
			const buffer = source ? await $mol_wire_async( source ).buffer() : null
			const conn = await this.connection_async()
			const alias = this.alias( file_name ).replace( 'wordstat_source_', 'mentionstat_source_' )
			if( !buffer ) {
				await conn.query( `
					CREATE OR REPLACE TEMP TABLE mention_stats_empty AS
					SELECT NULL::DATE AS date, 0::BIGINT AS count, ''::VARCHAR AS query,
						''::VARCHAR AS excluded_words, ''::VARCHAR AS scope, ''::VARCHAR AS country,
						''::VARCHAR AS language, ''::VARCHAR AS search_type, ''::VARCHAR AS tags,
						''::VARCHAR AS category, ''::VARCHAR AS item_id
					WHERE FALSE;
				` )
				return 'mention_stats_empty'
			}

			const table = `${ this.sql_ident( alias ) }.main.${ this.sql_ident( 'mention_stats' ) }`
			let attach = $shm_wordstat_data.attach_promises.get( alias )
			if( !attach ) {
				attach = ( async()=> {
					const db = await $shm_duckdb.db_async()
					const filename = file_name || this.registered_name()
					try { await db.dropFile( filename ) } catch( _ ) {}
					await db.registerFileBuffer( filename, new Uint8Array( buffer.slice( 0 ) ) )
					await conn.query( `ATTACH ${ this.sql_text( filename ) } AS ${ this.sql_ident( alias ) } (READ_ONLY);` )
				} )()
				$shm_wordstat_data.attach_promises.set( alias, attach )
			}
			try {
				await attach
			} catch( error ) {
				if( $shm_wordstat_data.attach_promises.get( alias ) === attach ) $shm_wordstat_data.attach_promises.delete( alias )
				throw error
			}
			return table
		}

		where_sql() {
			return [
				`COALESCE( query, '' ) IN (${ this.list_sql( this.queries() ) })`,
				`COALESCE( scope, '' ) IN (${ this.list_sql( this.scopes() ) })`,
				`COALESCE( country, '' ) IN (${ this.list_sql( this.countries() ) })`,
				`COALESCE( language, '' ) IN (${ this.list_sql( this.languages() ) })`,
				`COALESCE( search_type, '' ) IN (${ this.list_sql( this.types() ) })`,
				`COALESCE( category, '' ) IN (${ this.list_sql( this.categories() ) })`,
				`date BETWEEN DATE ${ this.sql_text( this.date_from() ) } AND DATE ${ this.sql_text( this.date_to() ) }`,
			].join( '\n\t\t\t\t\tAND ' )
		}

		@ $mol_mem
		query_table() {
			const table = this.table_ready()
			return this.query( `
				SELECT query AS "Запрос", SUM( count ) AS "Кол-во", scope AS "Источник",
					country AS "Страна", language AS "Язык", search_type AS "Тип",
					category AS "Категория", CAST( MIN( date ) AS VARCHAR ) AS "С",
					CAST( MAX( date ) AS VARCHAR ) AS "По"
				FROM ${ table }
				WHERE ${ this.where_sql() }
				GROUP BY query, scope, country, language, search_type, category
				ORDER BY "Кол-во" DESC, query, scope;
			` )
		}

		@ $mol_mem
		chart_timeseries() {
			const table = this.table_ready()
			const interval = ({ day: 'day', week: 'week', month: 'month', year: 'year' } as Record< string, string >)[ this.group() ] ?? 'day'
			const result = this.query( `
				SELECT CAST( date_trunc( '${ interval }', date ) AS DATE )::VARCHAR, query, scope, country, SUM( count )
				FROM ${ table }
				WHERE ${ this.where_sql() }
				GROUP BY 1, 2, 3, 4
				ORDER BY 1, 2, 3, 4;
			` )
			return result.rows.map( row => [ String( row[0] ), Number( row[4] || 0 ), `${ row[1] } · ${ row[2] } · ${ row[3] }` ] as const )
		}
	}
}
